import { render, staticRenderFns } from "./KritikStok.vue?vue&type=template&id=4a255356&scoped=true"
import script from "./KritikStok.vue?vue&type=script&lang=js"
export * from "./KritikStok.vue?vue&type=script&lang=js"
import style0 from "./KritikStok.vue?vue&type=style&index=0&id=4a255356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a255356",
  null
  
)

export default component.exports